import { DEVICE_NOT_FOUND_ERROR } from "./codes.constants.error";
import ApiError from "../../errors/ApiError";

export class DeviceNotFoundError extends ApiError {
  constructor() {
    super(DEVICE_NOT_FOUND_ERROR);
  }
}
